import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, normalizeClass as _normalizeClass, createVNode as _createVNode, createElementVNode as _createElementVNode, withCtx as _withCtx, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "preview" }
const _hoisted_2 = {
  key: 0,
  class: "count top-left"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_XImg = _resolveComponent("XImg")!
  const _component_LIcon = _resolveComponent("LIcon")!
  const _component_LMarker = _resolveComponent("LMarker")!
  const _component_MapStandalone = _resolveComponent("MapStandalone")!

  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass({
      'map-matter': true,
      'anim-markers': _ctx.animMarkers,
    })
  }, [
    _createVNode(_component_MapStandalone, {
      ref: "standalone",
      zoom: _ctx.zoom,
      "scroll-wheel-zoom": true,
      onReady: _ctx.onMapReady,
      onMoveend: _ctx.refreshDebounced,
      onZoomend: _ctx.refreshDebounced
    }, {
      default: _withCtx(() => [
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.clusters, (cluster) => {
          return (_openBlock(), _createBlock(_component_LMarker, {
            key: cluster.id,
            "lat-lng": cluster.center,
            onClick: ($event: any) => (_ctx.zoomTo(cluster))
          }, {
            default: _withCtx(() => [
              _createVNode(_component_LIcon, {
                "icon-anchor": [24, 24],
                className: _ctx.clusterIconClass(cluster)
              }, {
                default: _withCtx(() => [
                  _createElementVNode("div", _hoisted_1, [
                    (cluster.count > 1)
                      ? (_openBlock(), _createElementBlock("div", _hoisted_2, _toDisplayString(cluster.count), 1))
                      : _createCommentVNode("", true),
                    _createVNode(_component_XImg, {
                      src: _ctx.clusterPreviewUrl(cluster),
                      class: _normalizeClass(['thumb-important', `memories-thumb-${cluster.preview.fileid}`])
                    }, null, 8, ["src", "class"])
                  ])
                ]),
                _: 2
              }, 1032, ["className"])
            ]),
            _: 2
          }, 1032, ["lat-lng", "onClick"]))
        }), 128))
      ]),
      _: 1
    }, 8, ["zoom", "onReady", "onMoveend", "onZoomend"])
  ], 2))
}